import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoginLayoutService {
  // removeBanner = signal<boolean>(false);
  // removeBanner = new BehaviorSubject<boolean>(false);
}
